var render = function render(){var _vm=this,_c=_vm._self._c;return _c('container',{staticStyle:{"max-width":"800px"}},[_c('v-card',[_c('v-app-bar',{attrs:{"flat":"","color":"white"}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$capitalize(_vm.$tc("model.reminder_reminders_title"))))])],1),_c('ReminderList',{attrs:{"id":"page","has-counter":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }